import React, { useState, useEffect, useMemo, useContext } from 'react';
import Secured from 'Secured';
import { differenceBy } from 'lodash';

import App from 'contexts/App';
import UserContext from 'contexts/UserContext';
import Modal from 'components/Modal';
import Course from 'containers/Administrator/Users/Create_Old/Teacher/Courses/Add/Course';
import { Select } from 'components/Form';

const Add = Secured(({ request, modal, handleModal }) => {
	// Use app's context
	const { notify } = useContext(App);

	// Use user's context
	const { user } = useContext(UserContext);

	// Store search parameters
	const [parameters, setParameters] = useState({
		eager: '[subject, teacher]',
		subjectId: 31
	});

	// Store courses
	const [courses, setCourses] = useState([]);

	// Store subjects
	const [subjects, setSubjects] = useState([]);

	// Store available courses for selection
	const available = useMemo(() =>
		differenceBy(courses, user.courses, 'id')
	, [courses, user.courses]);

	// Handles search field's onChange event
	// @event: object | native onChange event
	const onChange = event => {
		const { name, value } = event.target || event;
		setParameters({
			...parameters,
			[name]: value
		});
	};

	useEffect(() => {
		request('get', 'subjects', null, null, res => {
			if (!res.error) return setSubjects(res);
		});
	}, [request]);

	useEffect(() => {
		// If modal is closed, clear stored courses
		if (!modal || !parameters.subjectId) return setCourses([]);

		// Collect courses with given parameters
		request('get', 'courses', parameters, null, res => {
			// Update course's state
			if (!res.error) return setCourses(res);

			// Create notification
			notify('warning', res.error);
		});
	}, [modal, parameters, request, notify]);

	return (
		<Modal title="Pievienot moduli" visible={modal} handleModal={handleModal}>
			<div className="modal__search withMarginTop">
				<Select
					name="subjectId"
					value={parameters.subjectId}
					onChange={onChange}
					options={subjects.map(subject => ({
						value: subject.id,
						text: subject.title
					}))}
				/>
			</div>

			<div className="teacherCourses withMarginTop">
				{available.map(course =>
					<Course key={course.id} course={course} />
				)}
			</div>
		</Modal>
	);
});

export default Add;